<template>
    <div><!-- --{{loadServiceRequest}}+loadServiceRequest={{serviceRequest}}+serviceRequest={{reason}}+reason={{reason_text}}+reason_text={{title}}+title={{title_text}}+title_text={{inList_custom_id}}+inList_custom_id={{info_req}}+info_req= -->
         <complete-loading :pageloader_value="pageLoader" :type="'complete'" v-if="pageLoader"></complete-loading>
        <div class=" middleBox "> <message-component :message="response_msg" :messageType="msg_type" v-if="response_msg != ''"></message-component></div>
        <div class="inMiddle-area" v-if="parseInt(div_show) == 1">  
            <div class="row justify-content-center align-items-center ">
                <div class=" middleBox ">
                    <div class="whiteBG box-shadow supportHome">
                        <div class="miAppName gradientThemecolor w-100 ">
                            <div> 
                                <label class="font-weight-bold f-25">{{$t('suppReqService_support')}}</label>
                                <p>{{$t('suppReqService_howassist')}}</p>
                            </div>
                            <figure><img src="../../../../static/fxView/images/support-New.svg" alt="Image" ></figure>
                        </div>
                        <div class="cardSection">
                            <div class="card-item mt-4 border-bottom d-flex pb-4  align-items-center"> 
                                <div class=" card-icon mr-3"> 
                                     <feather type="mail" size="17px"></feather>
                                </div> 
                                <div class="card-item-title "> 
                                    <label class="main-content-label tx-13 font-weight-bold mb-0">{{$t('suppReqService_emailus')}}</label> 
                                    <p>{{$t('suppReqService_email')}}</p>   
                                </div>
                            </div>
                            <div class="card-item mt-4 border-bottom d-flex pb-4  align-items-center"> 
                                <div class="card-icon mr-3"> 
                                     <feather type="message-circle" size="17px"></feather>
                                </div> 
                                <div class="card-item-title "> 
                                    <label class="main-content-label tx-13 font-weight-bold mb-0">{{$t('suppReqService_liveChat')}}</label> 
                                    <p>{{$t('suppReqService_avail24')}}</p>   
                                </div>
                            </div>
                            <div class="card-item mt-4 border-bottom d-flex pb-4  align-items-center"> 
                                <div class=" card-icon mr-3"> 
                                     <feather type="phone-outgoing" size="17px"></feather>
                                </div> 
                                <div class="card-item-title position-relative pointer" v-on:click.prevent="div_show = '3'"> 
                                    <div class="d-flex justify-content-between align-items-center">
                                        <div class="card-item-title d-flex align-items-center justify-content-between">
                                            <span>
                                                <label class="main-content-label tx-13 font-weight-bold mb-0">{{$t('suppReqService_requestcallback')}}</label> 
                                                <p>{{$t('suppReqService_office')}}</p> 
                                                <p>{{$t('suppReqService_support_phn')}}</p>
                                            </span>
                                            <a href="#" class="rqst position-absolute"><feather size="25px" type="arrow-right-circle"></feather></a>

                                        </div>
                                        <!-- <div>
                                            <p>+357-2526-2288 </p> 
                                            <p >+357-2526-2040</p> 
                                        </div> -->
                                    </div>  
                                </div>
                            </div>
                            <div class="card-item mt-4 d-flex pb-3 align-items-center"> 
                                <div class=" card-icon mr-3"> 
                                     <feather type="settings" size="17px"></feather>
                                </div> 
                                <div class="card-item-title d-flex  align-items-center justify-content-between"> 
                                    <label class="main-content-label tx-13 font-weight-bold mb-0">{{$t('suppReqService_support')}}</label> 
                                    <p><a href="#" class="green" @click="createTicketEvent()">{{$t('suppReqService_createTicket')}}</a> </p> 
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div> 
        </div>
        <div class="stepForm customContactForm scrollbar" v-else-if="parseInt(div_show) == 3">
            <h3>Contact Form</h3>
            <div class="row">
                <div class="col-12 col-md-6">
                    <div class="form-group field-wrapper">
                        <div class="position-relative">
                            <input placeholder=" " type="text" name="full name"  v-model="name" :class="({ 'is-invalid': submitted && errors.has('full name') })" class="float-field form-control" v-validate="'required'"/>
                            <label for="username" class="float-label">{{$t('fxFullRealName')}}</label>
                            <p class="error" v-if="submitted" v-for="error in errors.collect('full name')">{{ error }}</p>
                        </div>
                    </div>
                </div>
                <div class="col-12 col-md-6">
                    <div class="form-group field-wrapper">
                        <div class="position-relative">
                            <input placeholder=" " type="text" name="phone number" v-model="phone" :class="({ 'is-invalid': submitted && errors.has('phone number') })" class="float-field form-control" v-validate="{required: true,min:8, max:15}" />
                            <label for="username" class="float-label">{{ $t('fxPhoneNumber') }}</label>
                            <p class="error" v-if="submitted" v-for="error in errors.collect('phone number')">
                                <span v-show="submitted && error == 'The phone number field is required.'">{{$t('step1_phnoRequired')}}</span>
                                <span v-show="error == 'The phone number field must be at least 8 characters.'">{{$t('step1_minimumph')}}</span>
                                <span v-show="error == 'The phone number field may not be greater than 15 characters.'">{{$t('step1_maxphone')}}</span>
                            </p>
                        </div>
                    </div>
                </div>
                <div class="col-12">
                    <div class="form-group field-wrapper">
                        <div class="position-relative">
                            <select class="mdb-select md-form float-field form-control active" :class="({ 'is-invalid': submitted && errors.has('timezone_offset') })" v-model="value" onclick="this.setAttribute('value', this.value);" value="" name="timezone_offset" id="timezone-offset" v-validate="'required'">
                                <option value=""></option>
                                <option value="-12:00">(GMT -12:00) Eniwetok, Kwajalein</option>
                                <option value="-11:00">(GMT -11:00) Midway Island, Samoa</option>
                                <option value="-10:00">(GMT -10:00) Hawaii</option>
                                <option value="-09:50">(GMT -9:30) Taiohae</option>
                                <option value="-09:00">(GMT -9:00) Alaska</option>
                                <option value="-08:00">(GMT -8:00) Pacific Time (US &amp; Canada)</option>
                                <option value="-07:00">(GMT -7:00) Mountain Time (US &amp; Canada)</option>
                                <option value="-06:00">(GMT -6:00) Central Time (US &amp; Canada), Mexico City</option>
                                <option value="-05:00">(GMT -5:00) Eastern Time (US &amp; Canada), Bogota, Lima</option>
                                <option value="-04:50">(GMT -4:30) Caracas</option>
                                <option value="-04:00">(GMT -4:00) Atlantic Time (Canada), Caracas, La Paz</option>
                                <option value="-03:50">(GMT -3:30) Newfoundland</option>
                                <option value="-03:00">(GMT -3:00) Brazil, Buenos Aires, Georgetown</option>
                                <option value="-02:00">(GMT -2:00) Mid-Atlantic</option>
                                <option value="-01:00">(GMT -1:00) Azores, Cape Verde Islands</option>
                                <option value="+00:00" selected="selected">(GMT) Western Europe Time, London, Lisbon, Casablanca</option>
                                <option value="+01:00">(GMT +1:00) Brussels, Copenhagen, Madrid, Paris</option>
                                <option value="+02:00">(GMT +2:00) Kaliningrad, South Africa</option>
                                <option value="+03:00">(GMT +3:00) Baghdad, Riyadh, Moscow, St. Petersburg</option>
                                <option value="+03:50">(GMT +3:30) Tehran</option>
                                <option value="+04:00">(GMT +4:00) Abu Dhabi, Muscat, Baku, Tbilisi</option>
                                <option value="+04:50">(GMT +4:30) Kabul</option>
                                <option value="+05:00">(GMT +5:00) Ekaterinburg, Islamabad, Karachi, Tashkent</option>
                                <option value="+05:50">(GMT +5:30) Bombay, Calcutta, Madras, New Delhi</option>
                                <option value="+05:75">(GMT +5:45) Kathmandu, Pokhara</option>
                                <option value="+06:00">(GMT +6:00) Almaty, Dhaka, Colombo</option>
                                <option value="+06:50">(GMT +6:30) Yangon, Mandalay</option>
                                <option value="+07:00">(GMT +7:00) Bangkok, Hanoi, Jakarta</option>
                                <option value="+08:00">(GMT +8:00) Beijing, Perth, Singapore, Hong Kong</option>
                                <option value="+08:75">(GMT +8:45) Eucla</option>
                                <option value="+09:00">(GMT +9:00) Tokyo, Seoul, Osaka, Sapporo, Yakutsk</option>
                                <option value="+09:50">(GMT +9:30) Adelaide, Darwin</option>
                                <option value="+10:00">(GMT +10:00) Eastern Australia, Guam, Vladivostok</option>
                                <option value="+10:50">(GMT +10:30) Lord Howe Island</option>
                                <option value="+11:00">(GMT +11:00) Magadan, Solomon Islands, New Caledonia</option>
                                <option value="+11:50">(GMT +11:30) Norfolk Island</option>
                                <option value="+12:00">(GMT +12:00) Auckland, Wellington, Fiji, Kamchatka</option>
                                <option value="+12:75">(GMT +12:45) Chatham Islands</option>
                                <option value="+13:00">(GMT +13:00) Apia, Nukualofa</option>
                                <option value="+14:00">(GMT +14:00) Line Islands, Tokelau</option>
                            </select>
                            <label for="username" class="float-label">{{ $t('fxGMT') }}</label>
                            <p class="error" v-if="submitted"  v-for="error in errors.collect('timezone_offset')">
                                <span v-show="submitted && error == 'The timezone_offset field is required.'">{{$t('contactReq')}}</span>
                            </p>
                        </div>
                    </div>
                </div>
                <div class="col-12">
                    <div class="form-group field-wrapper">
                        <div class="position-relative">
                            <textarea placeholder=" "  name="comment" v-model="comment" :class="({ 'is-invalid': submitted && errors.has('comment') })" class="float-field form-control" v-validate="'required'"></textarea>
                            <label for="username" class="float-label">{{ $t('fxQuestionComments') }}</label>
                            <p class="error" v-if="submitted" v-for="error in errors.collect('comment')">{{ error }}</p>
                        </div>
                    </div>
                </div>
                <div class="col-12">
                    <div class="capticha">
                        <vue-recaptcha class="captchaRegister"
                            sitekey="6LcivBArAAAAADQ5sZSOf-5bbKHlE0pmqDxDt-ax" ref="recaptcha"
                            @verify="onCaptchaVerified" @expired="onCaptchaExpired"
                            size="visible"></vue-recaptcha>
                        <p class="error">
                            <span v-if="captachErr">{{ $t("reg_captchaErr") }}</span>
                        </p>
                    </div>
                </div>
                <div class="col-12">
                    <div class=" d-flex justify-content-between align-items-center ">
                        <a href="#" class="prism_btn redBG btn_xs mt-3"  v-on:click.prevent="div_show = '1'">{{$t('fxBack')}}</a>
                        <button class="prism_btn btn_xs btn_lg mt-3" @click.prevent="submitRequestCall()">{{$t('fxSubmit')}}</button>
                        
                    </div>
                </div>
            </div>
        </div>
        <div v-else-if="parseInt(div_show) == 2">  
            <div class="request_changesec" v-if="!serviceRequest"> 
                <div class="row d-flex justify-content-center align-items-center">
                    <div class="col-11 col-md-12">  
                        <div class="compose_mailsec">
                            <app-profile :ticketFilter="ticketReasonList[loadServiceRequest]"  :ticketRequest="ticketRequestFrom" :accountIdFrom="account_id" ></app-profile>
                        </div>                  
                    </div> 
                </div> 
            </div>
            <div class="main_inner_section services_request mb-3" v-else>
                <div class="row no-gutters justify-content-center">
                    <div class="col-12 col-md-12 whiteBG p-2"> 
                        <div class="support_search row d-flex align-items-center justify-content-center mb-3 pt-4 pb-2"> 
                            <div class="col-6 text-center">
                                <h2 class="support_title mb-4">{{$t('suppReqService_helpSupport')}}</h2>
                                <div class="form-group field-wrapper">
                                    <input type="text" class="form-control input_search inputs" id="myInput" name="" :placeholder="$t('SearchSomething')" v-on:keyup="keymonitor">
                                    <input type="submit" class="pos_ab" value="search" name="">
                                </div>
                            </div>  
                           
                        </div>
                        <div id="major_service_sec" class="outer_major_sersec">
                            <ul class="inner_dropdown request_lisec mb-5" id="myUL" v-if="ticketReasonList != ''">  
            					<li v-for="list in ticketData[-1]" v-if="ticketShowFunc(list) ">
                                    <a href="javascript:void(0)" v-on:click.prevent="enableRequestElement(list, ticketReasonList[list].title)" >
                                        <div class="icon">
                                            <img :src="'../../../../static/fxView/images/'+((iconFile.hasOwnProperty(list))?iconFile[list].icon : iconFile['-1'].icon)" alt="Email Support">
                                        </div>
                                        <h6  v-if="parseInt(list) == 191"> {{$t('fxIslamicAccount')}}</h6>
                                        <h6 v-html="((iconFile.hasOwnProperty(list))? $t(iconFile[list].lang)  : ticketReasonList[list].title)" v-else></h6>
                                    </a>
                                </li>
                            </ul>
                        </div>
                        
                    </div>
                </div>
            </div>
            <div class="goback text-center d-flex align-items-center justify-content-center mt-4">
                <a class="common_btn btn_xs  mb-5 d-flex align-items-center" href="#" v-if="loadServiceRequest != ''" v-on:click.prevent="backTick()">
                    <feather type="chevron-left" class="mr-1"></feather> {{$t('suppReqService_back')}}
                </a>
                <a class="common_btn btn_xs  mb-5 d-flex align-items-center" href="#" v-else v-on:click.prevent="div_show = '1'">
                    <feather type="chevron-left" class="mr-1"></feather> {{$t('suppReqService_back')}}
                </a>  
            </div>
            <div class="clearfix"></div>
        </div>
    </div>
</template>
<script>      
    import { fxViewMixins } from '@/plugins/fxView'  
    import profileRequest from './services/profile_request'
    import VueRecaptcha from 'vue-recaptcha';
    export default {
        name: 'SERVICES',
        mixins: [fxViewMixins],
        data () {
          return {
            pageTitle : this.$options.name,
            div_show : "1",
			iconFile :{ 
                '-1': {'icon':  'sr_profile.png','title': "Profile",'lang':'profile'},
                '1': {'icon':  'sr_profile.png','title': "Profile",'lang':'profile'},
                '2': {'icon': 'sr_tradingaccount.png' , 'title': "Trading Account",'lang':'createzullu_tradingAcc'},
				'3': {'icon':  'otherTicket.svg' , 'title': "PAMM Requests",'lang':''},
                '4': {'icon':  'otherTicket.svg' , 'title': "IB Requests",'lang':''},
                '5': {'icon':  'sr_deposit.png' , 'title': "Deposits",'lang':'Deposits'},
                '6': {'icon':  'sr_withdrawals.png' , 'title': "Withdrawals",'lang':'Withdrawals'},
				'7': {'icon':  'sr_bonus.png' , 'title': "Bonus",'lang':''},
                '8': {'icon':  'sr_vps.png' , 'title': "VPS",'lang':'VPS'},
				'9': {'icon':  'sr_reimbursement.png', 'title': "Reimbursement",'lang':''},
                '10': {'icon':  'sr_complaints.png' , 'title': "Complaints",'lang':'Complaints'},
				'11': {'icon': 'sr_compliance.png' , 'title': "Compliance",'lang':''},
                '12': {'icon': 'sr_feedback.png' , 'title': "Feedback",'lang':'Feedback'},
                '13': {'icon': 'sr_others.png' , 'title': "Others",'lang':'Others'},
                '16': {'icon': 'sr_addpayment.png', 'title': "Add Payment Method",'lang':'suppReqService_AddPaymentMethod'},
				'91': {'icon': 'otherTicket.svg', 'title': "Registeration Documents",'lang':''},
                '92': {'icon': 'otherTicket.svg', 'title': "Skip Documents",'lang':''},
				'94': {'icon': 'otherTicket.svg', 'title': "Become A Pro",'lang':''},
                '122':{'icon': 'sr-zulu.svg', 'title': "ZULU",'lang':'ZULU'},
                '133':{'icon': 'sr-mql5.svg', 'title': "MQL5",'lang':'MQL5'},
                '139':{'icon': 'sr-deposit-bonus.svg', 'title': "DEPOSIT BONUS",'lang':'depositBonus'},
                '147':{'icon': 'sr-refer-a-friend.svg', 'title': "Refer a Friend",'lang':'referfriend'},
                '159':{'icon': 'sr-wallet.svg', 'title': "Wallet",'lang':'supp_Wallet'}
                
            },
            loadServiceRequest : "",
            serviceRequest : true,
            

            //come request from deposit----
            ticketRequestFrom : '',
            account_id : '',
            method_id : '',
			inList_custom_id : '',
			
			showDiv : '1',
			reason : '',
			reason_text : '',
			title : '0',
			title_text : '',
			info_req : '',
            captchaVerified: false,
            captchaToken: '',
            captachErr: false,
            name :'',
            phone :'',
            value :'+00:00',
            comment :'',
            submitted : false,
            pageLoader : false,
            response_msg : '',
            msg_type : '',

          }
        }, 
        components: {
            appProfile: profileRequest,
            VueRecaptcha
        },
		
        methods: {

            createTicketEvent(){
                this.$trackEvent('CP+Support+Ticket');
                this.div_show = '2'
            },
            ticketShowFunc(getId){
                // console.log(getId, this.ticketReasonList[getId].status , parseInt(this.ticketReasonList[getId].tickets) , this.get_user.verified_status )
                if(parseInt(this.ticketReasonList[getId].status) == 1 && parseInt(this.ticketReasonList[getId].tickets) == 1 ){
                    if(getId != '16' && getId != '191'){
                        return true ;
                    }else if(getId == '16' && parseInt(this.get_user.verified_status) >= 1){
                        return true ;
                    }else if(getId == '191' && parseInt(this.get_user.pro_user) == 0){
                        return true ;
                    }else{
                        return false ;
                    }
                }else{
                    return false ;
                }
            },
            onCaptchaVerified: function (recaptchaToken) {
                const self = this;

                this.captchaVerified = true;
                this.captchaToken = recaptchaToken;
                // self.$refs.recaptcha.reset();
                this.submitRequestCallbackFunc();
            },
            onCaptchaExpired: function () {
              this.$refs.recaptcha.reset();
            },
            backTick(){
                this.loadServiceRequest = ''
                this.serviceRequest = true
                this.reason = '',
                this.reason_text = '',
                this.title = '0',
                this.title_text = ''
                this.inList_custom_id = ''
                this.info_req = ''
            },
			keymonitor(){
				var input, filter, ul, li, a, i, txtValue;
                  input = document.getElementById('myInput');
                  filter = input.value.toUpperCase();
                  ul = document.getElementById("myUL");
                  li = ul.getElementsByTagName('li');

                  // Loop through all list items, and hide those who don't match the search query
                  for (i = 0; i < li.length; i++) {
                    a = li[i].getElementsByTagName("a")[0];
                   
                    txtValue = a.textContent || a.innerText;
                    
                    if (txtValue.toUpperCase().indexOf(filter) > -1) {
                      li[i].style.display = "";
                    } else {
                      li[i].style.display = "none";
                    }
                  }
			},
            enableRequestElement(elementName, name){
                console.log(' name is', name);

                switch (name) {
                case 'Profile':
                    this.$trackEvent('CP+Support+Ticket+Profile');
                    break;
                case 'Trading Account':
                    this.$trackEvent('CP+Support+Ticket+Trading+Accounts');
                    break;
                case 'Deposits':
                    this.$trackEvent('CP+Support+Ticket+Deposits');
                    break;
                case 'Deposit Alert':
                    this.$trackEvent('CP+Support+Ticket+Deposit+Alert');
                    break;
                case 'VPS':
                    this.$trackEvent('CP+Support+Ticket+VPS');
                    break;
                case 'Feedback':
                    this.$trackEvent('CP+Support+Ticket+Feedback');
                    break;
                case 'Others':
                    this.$trackEvent('CP+Support+Ticket+others');
                    break;
                case 'Increase Crypto Limit':
                    this.$trackEvent('CP+Support+Ticket+Increase+Crypto+Limit');
                    break;
                case 'ZULU':
                    this.$trackEvent('CP+Support+Ticket+Zulu');
                    break;
                case 'MQL5':
                    this.$trackEvent('CP+Support+Ticket+MQL5');
                    break;
                case 'DEPOSIT BONUS':
                    this.$trackEvent('CP+Support+Ticket+Deposit+Bonus');
                    break;
                case 'Refer a Friend':
                    this.$trackEvent('CP+Support+Ticket+Refer+a+Friend');
                    break;
                case 'Wallet':
                    this.$trackEvent('CP+Support+Ticket+Wallet');
                    break;
                case 'Enable Islamic account':
                    this.$trackEvent('CP+Support+Ticket+Islamic+Account');
                    break;
                case 'Add Payment Method':
                    this.$trackEvent('CP+Support+Ticket+add+Payment+Method');
                    break;
                case 'Withdrawals':
                    this.$trackEvent('CP+Support+Ticket+Withdrawals');
                    break;
                }   

				this.loadServiceRequest =  elementName
                //console.log('=========el',this.ticketReasonList[this.loadServiceRequest])
				if(!parseInt(this.ticketReasonList[this.loadServiceRequest].infomration_req) || (parseInt(this.loadServiceRequest) == 16 && this.method_id != '')){
					this.showDiv = '3'
                    this.div_show = '2'
					if(parseInt(this.loadServiceRequest) == 16){
						this.chooseRequestType(this.inList_custom_id,this.ticketReasonList[this.loadServiceRequest])
					}else{
						this.chooseRequestType('',this.ticketReasonList[this.loadServiceRequest])
					}
				}else{
                    this.showDiv = '1'
                    this.div_show = '2'
                }
				this.serviceRequest = false
            },
			chooseRequestType(getInlistId,getOutListData){
                this.reason = getOutListData.id
                this.reason_text = getOutListData.title
				this.title = '0'
                this.title_text = '' 
				if(getInlistId != '' && getInlistId != null){
					let count = 0;
					for(var key in  this.ticketReasonList[this.loadServiceRequest].categories){
						count++
						if(key == getInlistId){
							this.title = key
							this.title_text = this.ticketReasonList[this.loadServiceRequest].categories[key].title
							this.info_req = this.ticketReasonList[this.loadServiceRequest].categories[key].infomration_req
						}
						if(count == Object.keys(this.ticketReasonList[this.loadServiceRequest].categories).length){
							if(!parseInt(this.info_req)){
								this.showDiv = '3'
                                this.div_show = '2'
							}else{
								this.showDiv = '2'
                                this.div_show = '2'
							}
						}
					}
				}else{
					this.showDiv = '3'
                    this.div_show = '2'
				}
            },
            submitRequestCall() {
                const _that = this;
                _that.$refs.recaptcha.execute();
            },
            submitRequestCallbackFunc(){
                 const _that = this
                _that.submitted = true;
                _that.$validator.validate().then(valid => {
                    if (valid) {
                        if(!(this.captchaVerified)){
                            _that.captachErr = true
                            _that.submitted = false;
                        }
                        else{
                            _that.submitted = false;
                            let description = 'client '+' '+_that.name+' '+'<br>'+' '+'has requested for a callback, his/her mobile number is'+' '+_that.phone+' '+'<br>'+' '+'and preferred time is '+' '+ _that.value+'. '+'<br>'+' '+'client`s comment : '+' '+_that.comment
                            let input_json={
                                globalParams :{
                                    title : 'REQUEST CALLBACK',
                                    description : description,
                                    captchaToken: this.captchaToken,
                                    
                                },
                                localParams :{ parameter : _that }
                            }
                            _that._runRequestCallback(input_json)
                            _that.$refs.recaptcha.reset();
                        }
                    }
                });
            },
            reset(){
                this.submitted = false
                this.captchaVerified = false
                this.name = ''
                this.phone = ''
                this.value = ''
                this.comment = ''
            },
            showIslamicTicket(){
                const _that = this
                this.div_show = '2'
                let id = _that.$route.query.ticketData
                this.$router.replace({query: null})
                setTimeout(function(){  
                    _that.enableRequestElement(parseInt(id)) 
                },4000);
            }

        },
        created(){
            if(parseInt(this.$route.params.ticketData) == 16){
                this.div_show = '2'
				if(this.$route.params.account_id){
					this.ticketRequestFrom = 'deposit'
					this.account_id = this.$route.params.account_id
				}
				if(this.$route.params.page == 'profile'){
					this.ticketRequestFrom = 'profile'
					this.account_id = ''
				}
                
                
                this.method_id = this.$route.params.method_id
				if(this.method_id == 1){
					this.inList_custom_id = 93
				}else if(this.method_id == 2){
					this.inList_custom_id = 95
				}else if(this.method_id == 3){
					this.inList_custom_id = 96
				}else if(this.method_id == 5){
					this.inList_custom_id = 107
				}
                this.enableRequestElement(16)
            }


            if(this.$route.query.ticketData && parseInt(this.$route.query.ticketData) == 191){
               this.showIslamicTicket()
            }
        }
    }
</script>


// WEBPACK FOOTER //
// src/components/fxView/supports/request_services.vue